'use strict';

import FormController from 'app/controllers/form';
// eslint-disable-next-line no-unused-vars
import ngAsync from 'app/async/async.function.decorator';

class ClientController extends FormController {
  /* @ngInject */
  constructor(
    ClientsService,
    ProvincesService,
    CitiesService,
    $scope,
    $mdToast,
    $mdDialog,
    $state,
    $location,
    $timeout
  ) {
    let client = $scope.$parent.$resolve.client;
    super(client, 'Cliente/Titular', ClientsService, null, 'clients');

    Object.assign(this, {
      ClientsService,
      ProvincesService,
      CitiesService,
      $mdToast,
      $mdDialog,
      $state,
      $location,
      $timeout
    });
    this.btnEnabled = true;
    if (!this.model.id) {
      Object.assign(this.model, {
        clientType: 'physical',
        nationality: 'ARG',
        legalAddress: {
          province: 'SF'
        }
      });
    }
    this.updateClientTypeFlags();
    this.updateNationality();
    this.updateLegalAddressProvince();
  }

  $onInit() {
    super.$onInit();

    //this.showDniLookupSpinner = true;
    //this.showDniLookupCheck = true;
  }

  @ngAsync()
  async onDniChange() {
    if (!this.model.dni) return;

    this.showDniLookupSpinner = true;
    this.dniLookup = this.ClientsService.find({
      filter: {
        where: {
          dni: this.model.dni
        }
      }
    });

    try {
      const existingClient = await this.dniLookup;
      this.dniLookup = null;
      this.showDniLookupSpinner = false;
      if (existingClient.length) {
        this.onExistingClient(existingClient[0].id);
      } else {
        this.showDniLookupCheck = true;
        this.calculateCuit();
        this.$timeout(() => {
          this.showDniLookupCheck = false;
        }, 2000);
      }
    } catch (e) {
      this.showDniLookupSpinner = false;
      this.showDniLookupCheck = false;
    }
  }

  @ngAsync()
  async onCuitChange() {
    if (!this.model.cuit) return;

    this.showCuitLookupSpinner = true;
    this.cuitLookup = this.ClientsService.find({
      filter: {
        where: {
          cuit: this.model.cuit
        }
      }
    });

    try {
      const existingClient = await this.cuitLookup;
      this.cuitLookup = null;
      this.showCuitLookupSpinner = false;
      if (existingClient.length) {
        this.onExistingClient(existingClient[0].id);
      } else {
        this.showCuitLookupCheck = true;
        this.$timeout(() => {
          this.showCuitLookupCheck = false;
        }, 2000);
      }
    } catch (e) {
      this.showCuitLookupSpinner = false;
      this.showCuitLookupCheck = false;
    }
  }

  save() {
    //Clear weeding info
    if (this.model.maritalStatus != 'C') {
      this.model.weeding = null;
      this.model.spouse = null;
      this.model.spouseDni = null;
    }

    super.save().catch(err => {
      this.showSpin = false;
      let error = err.data && err.data.error;
      let alreadyExists = error && error.code == 'CLIENT_ALREADY_EXISTS';
      let dniCuitRequired =
        error && error.code == 'CLIENT_DNI_OR_CUIT_REQUIRED';
      if (alreadyExists) {
        this.onExistingClient(error.clientId);
      } else if (dniCuitRequired) {
        this.simpleError('DNI o CUIT es requerido');
      }
    });
  }

  onExistingClient(clientId) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Cliente ya existe')
      .textContent(
        `Ya existe un cliente con mismo dni o cuit,
desea visualizarlo?`
      )
      .ariaLabel('Lucky day')
      //            .targetEvent(ev)
      .ok('Si, ir')
      .cancel('Cancelar y continuar en este cliente');

    this.$mdDialog.show(confirm).then(() => {
      this.$state.go('editClient', {
        id: clientId
      });
    });
  }

  onClientTypeChange() {
    this.updateClientTypeFlags();
    this.updateNationality();
  }

  updateClientTypeFlags() {
    this.isPhysicalType = this.model.clientType == 'physical' ? true : false;
    this.isJuridicalType = this.model.clientType == 'juridical' ? true : false;
  }

  onGenderChange() {
    this.calculateCuit();
  }

  calculateCuit() {
    if (this.model.cuit || !this.model.dni || !this.model.gender) return;

    this.model.cuit = this.ClientsService.calculateCuit(
      this.model.dni,
      this.model.gender
    );
  }

  queryNationalitySearch(text) {
    const results = this.ClientsService.findCountries(text);
    return results;
  }

  selectedNationalityItemChange(country) {
    this.model.nationality = country.alpha3Code;
  }

  updateNationality() {
    if (this.model.clientType == 'physical') {
      this.selectedNationalityItem = this.ClientsService.findCountryByCode(
        this.model.nationality
      );
    } else {
      this.model.nationality = null;
    }
  }

  queryProvincesSearch(text) {
    return this.ProvincesService.find({
      where: {
        name: {
          ilike: `%${text}%`
        }
      }
    });
  }

  selectedLegalAddressProvinceChange(province) {
    this.model.legalAddress.provinceId = province.id;
  }

  @ngAsync()
  async updateLegalAddressProvince() {
    if (this.model.clientType == 'physical') {
      this.selectedLegalAddressProvinceItem = await this.ProvincesService.findById(
        this.model.legalAddress.provinceId
      );
    } else {
      this.model.legalAddress.provinceId = null;
    }
  }

  onUpdateLegalCity($event) {
    this.model.legalAddress.cityId = $event.cityId;
  }
}

export default ClientController;
